"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const useStyles = makeStyles_1.default((theme) => ({
    inputContainer: {
        flex: "1 1 auto",
        display: "flex",
        borderRadius: 25,
        padding: "8px 15px 10px 15px",
        backgroundColor: theme.colors.textBox.backgroundColor,
        marginLeft: 6
    },
    input: {
        border: 0,
        outline: "none",
        flex: "1 1 auto",
        fontSize: 16,
        lineHeight: "20px",
        fontWeight: 400,
        color: theme.colors.textBox.textColor,
        whiteSpace: "pre-wrap",
        overflowX: "hidden",
        overflowY: "auto",
        zIndex: 1,
        minHeight: 20,
        maxHeight: 100,
        userSelect: "text",
        overflowWrap: "anywhere"
    }
}));
const MessageTextInput = react_1.forwardRef((props, ref) => {
    const classes = useStyles();
    // The saved textbox range selection - used to restore the selection when inserting emojis from the picker
    const savedRangeRef = react_1.useRef(null);
    const textBoxRef = react_1.useRef(null);
    react_1.useImperativeHandle(ref, () => ({
        insertEmoji,
        clearText,
        onFocusAway,
        onFocusBack
    }));
    function insertEmoji(nativeEmoji) {
        var _a, _b;
        // Focus on the message box and re-apply any saved range selection
        restoreSelection();
        // // Markup the text so it will appear correctly in the textbox and manually insert it
        document.execCommand("insertText", false, nativeEmoji);
        // Save the new selection range
        saveSelection();
        // Notify parent
        props.onChange((_b = (_a = textBoxRef.current) === null || _a === void 0 ? void 0 : _a.textContent) !== null && _b !== void 0 ? _b : "");
    }
    function onFocusAway() {
        clearSelection();
    }
    function onFocusBack() {
        restoreSelection();
    }
    function clearText() {
        var _a, _b;
        const textBox = textBoxRef.current;
        textBox.innerHTML = "";
        textBox.focus();
        props.onChange((_b = (_a = textBoxRef.current) === null || _a === void 0 ? void 0 : _a.textContent) !== null && _b !== void 0 ? _b : "");
    }
    function handleInput(e) {
        var _a, _b;
        if (e.target.innerHTML.trim() == "<br>") {
            e.target.innerHTML = "";
        }
        props.onChange((_b = (_a = textBoxRef.current) === null || _a === void 0 ? void 0 : _a.textContent) !== null && _b !== void 0 ? _b : "");
    }
    function pastePlainText(e) {
        var _a, _b;
        // Cancel the paste event
        e.preventDefault();
        // Get plain text representation of clipboard
        const text = e.clipboardData.getData('text/plain');
        // Manually insert text
        document.execCommand("insertText", false, text);
        // Notify parent
        props.onChange((_b = (_a = textBoxRef.current) === null || _a === void 0 ? void 0 : _a.textContent) !== null && _b !== void 0 ? _b : "");
    }
    function handleKeyPress(e) {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            e.stopPropagation();
            props.onEnterPressed();
        }
    }
    function saveSelection() {
        var _a, _b;
        // Save the textbox range selection so it can be restored when the textbox next gets focus
        savedRangeRef.current = (_b = (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.getRangeAt(0)) !== null && _b !== void 0 ? _b : null;
    }
    function restoreSelection() {
        // Set the focus on to the textbox
        const textBox = textBoxRef.current;
        textBox.focus();
        // Set the window selection to the last saved range. If there is no existing 
        // saved range then initialise one at the end of the text box.
        if (!savedRangeRef.current) {
            const range = new Range();
            range.selectNodeContents(textBox);
            range.collapse(false);
            savedRangeRef.current = range;
        }
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(savedRangeRef.current);
    }
    function clearSelection() {
        savedRangeRef.current = null;
    }
    return (react_1.default.createElement("div", { className: classes.inputContainer },
        react_1.default.createElement("div", { id: "textbox", ref: textBoxRef, className: classes.input, placeholder: props.placeholder, onInput: handleInput, onPaste: pastePlainText, onKeyDown: handleKeyPress, onBlur: saveSelection, contentEditable: true, spellCheck: "true" })));
});
exports.default = react_1.default.memo(MessageTextInput);
